import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import KitchenRemodeling from "../pages/services/kitchen-remodeling/page";
import BathroomRenovation from "../pages/services/bathroom-renovation/page";
import BasementFinishing from "../pages/services/basement-finishing/page";
import RoomAdditions from "../pages/services/room-additions/page";
import CustomCarpentry from "../pages/services/custom-carpentry/page";
import WholeHomeRemodeling from "../pages/services/whole-home-remodeling/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services/kitchen-remodeling",
    element: <KitchenRemodeling />,
  },
  {
    path: "/services/bathroom-renovation",
    element: <BathroomRenovation />,
  },
  {
    path: "/services/basement-finishing",
    element: <BasementFinishing />,
  },
  {
    path: "/services/room-additions",
    element: <RoomAdditions />,
  },
  {
    path: "/services/custom-carpentry",
    element: <CustomCarpentry />,
  },
  {
    path: "/services/whole-home-remodeling",
    element: <WholeHomeRemodeling />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;